import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useTourContext } from '@/shared/lib/context';
import { useTour } from '@/shared/lib/hooks';
import { Button } from '@/shared/ui/button';

const TourTriggerButtonComponent = memo(() => {
    const { t } = useTranslation('tour');
    const { steps } = useTour();
    const { openWelcomeModal } = useTourContext();

    const handleClick = () => {
        if (openWelcomeModal) {
            openWelcomeModal();
        }
    };

    if (!steps || steps.length === 0) {
        return null;
    }

    return (
        <Button
            data-tour="tour-trigger-button"
            onClick={handleClick}
            title={t('common.startTour')}
            variant="wiggle"
        />
    );
});

TourTriggerButtonComponent.displayName = 'TourTriggerButton';

export const TourTriggerButton = TourTriggerButtonComponent;
export default TourTriggerButtonComponent;
